import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import apiClient from "../../../api/apiClient";
import { Form, Button, Row, Col, Spinner } from "react-bootstrap";
import { Input, AlertMassage, PopupModel } from "../../shared";
import AddOptions from "./AddOptions";
import ViewOptions from "./ViewOptions";
import { EditIcon, ViewIcon, DeleteIcon, PlusIcon, BackArrowIcon } from '../../../utils/FontIcon';
import { publish, subscribe, unsubscribe } from '../../../utils/pubsubWrapper';
import { GETQUIZ } from '../../../utils/ApiEndPoint';

export default function AddQuestion() {
    const navigate = useNavigate();
    const [form, setForm] = useState({
        title: "",
        tags: "",
        skillLevel: '',
        description: "",
        questiontype: '',
        question: '',
    });
    const [errors, setErrors] = useState({});
    const [showAlert, setShowAlert] = useState({
        type: '',
        title: '',
        msg: ``,
        show: false
    })
    const [questions, setQuestions] = useState([]);

    const [popupData, setPopupData] = useState({
        show: false,
        title: '',
        type: '',
        selectedItem: {},
    });

    const [isEditMode, setIsEditMode] = useState({
        mode: false,
        id: '',
        createdBy: '',
        updatedBy: ''
    });
    const [waitForResponse, setWaitForResponse] = useState(false);

    useEffect(() => {
        const pubsubToken = subscribe('EDIT_QUESTION_GROUP', (questions) => {
            setForm({
                title: questions.title,
                tags: questions.tags.join(),
                description: questions.description,
                skillLevel: questions.skillLevel || '',
                questiontype: '',
                question: '',
            });
            setQuestions(questions.questions)
            setErrors({});
            setIsEditMode({ mode: true, id: questions._id, createdBy: questions.createdBy, updatedBy: questions.updatedBy });
        });
        return () => unsubscribe(pubsubToken);
    }, []);
    useEffect(() => {
        const pubsubToken = subscribe('SAVE_OPTIONS', (data) => {
            if (data.qindex !== '') {
                let tempQuestion = [...questions];
                tempQuestion[data.qindex].questionText = data.questionText;
                tempQuestion[data.qindex].type = data.questionType;
                tempQuestion[data.qindex].options = data.options;
                setErrors((prev) => ({ ...prev, [`question${data.qindex}`]: '' }));
                setQuestions(tempQuestion);
            } else {
                const question = {
                    "type": data.questionType,
                    "questionText": data.questionText,
                    "options": data.options,
                    'id': questions.length
                }
                let tempQuestions = [...questions];
                tempQuestions.push(question);
                setQuestions(tempQuestions);
            }
            handleCloseModal();
        });
        return () => unsubscribe(pubsubToken);
    }, [questions]);

    const handleChange = (e) => {
        const { name, value, files } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
        setErrors((prev) => ({ ...prev, [name]: undefined }));
    };
    const validate = () => {
        const newErrors = {};
        if (!form.title.trim()) newErrors.title = "Title is required";
        if (!form.tags.trim()) newErrors.tags = "Keywords are required";
        if (!form.skillLevel.trim()) newErrors.skillLevel = "Difficulty level is required";
        if (!form.description.trim()) newErrors.description = "Description is required";
        if (!questions.length) {
            newErrors.question = "Question is required";
        } 
        // else {
        //     questions.forEach((question, index) => {
        //         if (!question.options.length) {
        //             newErrors[`question${index}`] = `Options is required.`;
        //         }
        //     });
        // }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (!validationErrors) {
            return;
        }
        setWaitForResponse(true);
        isEditMode.mode ? saveAfterEdit() : savedata()
    };
    const savedata = () => {
        const data = {
            'title': form.title,
            'tags': form.tags,
            'description': form.description,
            'questions': questions,
            "skillLevel": form.skillLevel,
            "createdBy": "665a2bb1d2fe3a22ec8d3b12",
            "updatedBy": "665a2bb1d2fe3a22ec8d3b12"
        }
        let tempAlert = {
            type: 'danger',
            title: 'Error',
            msg: '',
            show: true
        }
        apiClient.post(GETQUIZ, data)
            .then((response) => {
                if (response.status === 201) {
                    tempAlert.type = 'success';
                    tempAlert.title = 'Success';
                    tempAlert.msg = '✅ Question Created successfully!';
                    setShowAlert(tempAlert)
                    resetForm();
                    publish('FETCH_QUESTION');
                } else {
                    tempAlert.msg = '❌ Question Creation failed.';
                    setShowAlert(tempAlert);
                }
            }).catch((error) => {
                tempAlert.msg = '❌ Question Creation failed.';
                setShowAlert(tempAlert);
            }).finally(() => {
                setWaitForResponse(false);
            });
    }
    const saveAfterEdit = async () => {
        const data = {
            'title': form.title,
            'tags': form.tags,
            'description': form.description,
            'questions': questions,
            "skillLevel": form.skillLevel,
            "createdBy": isEditMode.createdBy,
            "updatedBy": "665a2bb1d2fe3a22ec8d3b12"
        }

        let tempAlert = {
            type: 'danger',
            title: 'Error',
            msg: '',
            show: true
        }
        apiClient.put(`${GETQUIZ}/${isEditMode.id}`, data)
            .then((response) => {
                if (response.status === 200) {
                    tempAlert.type = 'success';
                    tempAlert.title = 'Success';
                    tempAlert.msg = `✅ Question Updated successfully!`;
                    setShowAlert(tempAlert)
                    resetForm();
                    publish('FETCH_QUESTION');
                } else {
                    tempAlert.msg = '❌ Question Update failed.';
                    setShowAlert(tempAlert);
                }
            }).catch((error) => {
                tempAlert.msg = '❌ Question Update failed.';
                setShowAlert(tempAlert);
            }).finally(() => {
                setWaitForResponse(false);
            });
    }

    const handelGotoCourse = (e) => {
        navigate('/createcourse');
    }
    const handelAddQuestion = (e) => {
        setPopupData({
            show: true,
            title: 'Add Question, Options and Answer',
            type: 'addoptions',
            selectedItem: '',
        })
        // if (form.question !== '') {
        //     const question = {
        //      console.log("🚀 krishna  ~ tempQuestion:", tempQuestion);    "type": '',//form.type,
        //         "questionText": form.question,
        //         "options": [],
        //         'id': questions.length
        //     }
        //     let tempQuestions = [...questions];
        //     tempQuestions.push(question);
        //     setQuestions(tempQuestions);
        //     setForm((prev) => ({
        //         ...prev,
        //         question: '',
        //     }));
        // }
        // else {
        //     setErrors((prev) => ({ ...prev, question: 'Question is required ' }));
        // }

    }
    const resetForm = () => {
        setForm({
            title: "",
            tags: "",
            description: "",
            questiontype: '',
            question: '',
        });
        setQuestions([]);
        setIsEditMode({
            mode: false,
            id: '',
            createdBy: '',
            updatedBy: ''
        });
        setErrors({});
        setPopupData({
            show: false,
            title: '',
            type: '',
            selectedItem: {},
        })
    }
    const handelDeleteQuestion = (indexToDelete) => {
        let tempQuestion = [...questions]
        tempQuestion.splice(indexToDelete, 1);
        setQuestions(tempQuestion);
    }
    const hideAlert = () => {
        setShowAlert({
            type: '',
            title: '',
            msg: '',
            show: false
        })
    }
    const handleCloseModal = () => {
        setPopupData({
            show: false,
            title: '',
            type: '',
            selectedItem: {},
        })
    };
    return (
        <div className="add-video-bg" >
            <Row>
                <Col xs={6} md={10}>
                    <h4 className="mb-0 fw-bold">Add Assessment</h4>
                    <div className="mb-2 ms-1 small fw-semibold text-secondary">(Upload/Listing)</div>
                </Col>

                <Col xs={6} md={2} className="text-end">
                    <Button variant="outline-dark" onClick={handelGotoCourse} title="Go to course"><BackArrowIcon />Go to course</Button>
                </Col>
            </Row>
            <Row>
                <Col md={12} className="add-video-container">
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={12} className="mb-3 fw-semibold fs-8 onerem pb-2">Start building your questions library.</Col>
                            <Col md={12} >
                                <Row>
                                    <Col md={4} xs={12}>
                                        <Input
                                            label="Title"
                                            isMandetory={true}
                                            name="title"
                                            value={form.title}
                                            onChange={handleChange}
                                            placeholder="enter question title"
                                            isInvalid={!!errors.title}
                                            feedback={errors.title}
                                            inlineFeedback={true}
                                            maxLength={80}
                                        />
                                    </Col>
                                    <Col md={4} xs={12}>
                                        <Input
                                            label="Keywords"
                                            isMandetory={true}
                                            name="tags"
                                            value={form.tags}
                                            onChange={handleChange}
                                            placeholder="enter Keywords (e.g.education, farmer, insurence etc)"
                                            isInvalid={!!errors.tags}
                                            feedback={errors.tags}
                                            inlineFeedback={true}
                                        />
                                    </Col>
                                    <Col md={4} xs={12}>
                                        <Input
                                            label="Difficulty level"
                                            type="select"
                                            name="skillLevel"
                                            value={form.skillLevel}
                                            onChange={handleChange}
                                            isInvalid={!!errors.skillLevel}
                                            feedback={errors.skillLevel}
                                            multiple={false}
                                            options={[
                                                { value: 'beginner', label: 'Beginner' },
                                                { value: 'intermediate', label: 'Intermediate' },
                                                { value: 'advanced', label: 'Advanced' }
                                            ]}
                                            isMandetory={true}
                                            inlineFeedback={true}
                                        />
                                    </Col>
                                    <Col xs={12}>
                                        <Input
                                            label="Description"
                                            isMandetory={true}
                                            name="description"
                                            value={form.description}
                                            onChange={handleChange}
                                            placeholder="Describe the Questionnaire or its purpose"
                                            isInvalid={!!errors.description}
                                            feedback={errors.description}
                                            as="textarea"
                                            rows={3}
                                            inlineFeedback={true}
                                            maxLength={500}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                             
                            <Col md={3} xs={12}>
                                <Button variant="outline-primary" title="Add Question" type="button" className="px-4 purple-btn h44" onClick={handelAddQuestion}>
                                    Add Question
                                </Button>
                            </Col>
                            <Col md={9} className="d-none d-md-block">  </Col>
                            <Col md={12}>
                                {questions.length ?
                                    <Col md={12}>
                                        <div className="w-100 border border-1 rounded-2 ">
                                            {questions.map((question, idx) => {
                                                const hasError = !errors[`question${idx}`] == '';
                                                return <div key={idx} className={`d-flex justify-content-between myquestion-bg overflow-hidden p-2 m-2 border border-1 ${hasError ? 'border-danger' : 'border-info'}`} style={{ backgroundColor: '#e6fff3', color: '#0d6efd' }}>
                                                    <span className="d-block">{`${idx + 1}. `}{question.questionText}</span>
                                                    <span className="d-flex" style={{ gap: '4px' }}>
                                                        {question.options && question.options.length ?
                                                            <Button type="button" className="float-end px-2 add-reference-btn" onClick={() => {
                                                                setPopupData({
                                                                    show: true,
                                                                    title: 'Question Preview',
                                                                    type: 'preview',
                                                                    selectedItem: idx,
                                                                })
                                                            }}>
                                                                <ViewIcon />
                                                            </Button> :
                                                            <Button type="button" className="float-end px-2 add-reference-btn" onClick={() => {
                                                                setPopupData({
                                                                    show: true,
                                                                    title: 'Add Options/ Answer',
                                                                    type: 'addoptions',
                                                                    selectedItem: idx,
                                                                })
                                                            }}>
                                                                <PlusIcon />
                                                            </Button>
                                                        }
                                                        {(question.options && question.options.length) ? <Button type="button" className="float-end px-2 add-reference-btn" onClick={() => {
                                                            setPopupData({
                                                                show: true,
                                                                title: 'Edit Options/ Answer',
                                                                type: 'editoptions',
                                                                selectedItem: idx,
                                                            })
                                                        }}>
                                                            <EditIcon />
                                                        </Button> : null}

                                                        <Button type="button" className="float-end px-2 add-reference-btn" onClick={() => { handelDeleteQuestion(idx) }}>
                                                            <DeleteIcon />
                                                        </Button>
                                                    </span>
                                                </div>
                                            }
                                            )}
                                        </div>
                                    </Col> : null}
                            </Col>
                        </Row>
                        <Row>
                            <div className="d-flex gap-3 justify-content-end mt-3">

                                <Button variant="outline-secondary" title="Reset" type="button" className="px-4" disabled={waitForResponse} onClick={resetForm}>
                                    Reset
                                </Button>
                                <Button type="submit" title="Save" className="save-btn px-5" disabled={waitForResponse}>
                                    {isEditMode.mode ? 'Update' : 'Save'}
                                </Button>
                            </div>
                        </Row>
                    </Form>
                </Col>
            </Row>
            {popupData.show && (
                popupData.type === 'confirm' ? (
                    <PopupModel
                        size="md"
                        showModal={popupData.show}
                        handleCloseModal={handleCloseModal}
                        title={popupData.title}
                        type={popupData.type}
                        footerContent={
                            <>
                                <Button variant="danger" onClick={handelDelete}>Yes</Button>
                                <Button variant="info" onClick={handleCloseModal}>No</Button>
                            </>
                        }
                    >
                        <p>
                            Are you sure you want todelete <strong>{popupData.selectedItem.title}</strong>? This action cannot be undone.
                        </p>
                    </PopupModel>
                ) : popupData.type === 'addoptions' || popupData.type === 'editoptions' ? (
                    <PopupModel
                        size="lg"
                        showModal={popupData.show}
                        handleCloseModal={handleCloseModal}
                        title={popupData.title}
                        type={popupData.type}
                    >
                        <AddOptions question={questions[popupData.selectedItem]} qindex={popupData.selectedItem} />
                    </PopupModel>
                ) : (
                    <PopupModel
                        size="lg"
                        showModal={popupData.show}
                        handleCloseModal={handleCloseModal}
                        title={popupData.title}
                        type={popupData.type}
                    >
                        <ViewOptions question={questions[popupData.selectedItem]} />
                    </PopupModel>
                )
            )}

            {showAlert.show &&
                <AlertMassage
                    show={showAlert.show}
                    type={showAlert.type}
                    title={showAlert.title}
                    massage={showAlert.msg}
                    hideAlert={hideAlert} />
            }

        </div>
    );
}